import React, { useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/auth/Login';
import LessonMenu from './components/LessonMenu';
import ExerciseMenu from './components/ExerciseMenu';
import Dashboard from './components/Dashboard';
import AdminDashboard from './components/admin/AdminDashboard';
import Loading from './components/Loading';
import ChatWidget from './components/chat/ChatWidget';
import BBBJoinButton from './components/bbb/BBBJoinButton';
import DictionaryPopupButton from './components/dictionary/DictionaryPopupButton';
import OfflineBanner from './components/shared/OfflineBanner';
import ConversationWriteExercise from './components/conversation/ConversationWriteExercise';
import ConversationFillInExercise from './components/conversation/ConversationFillInExercise';
import VocabularyFillInExercise from './components/volcabulary/VocabularyFillInExercise';
import GrammarFillInOrchestrator from './components/grammar/GrammarFillInOrchestrator';
import SpeakingExercise from './components/speaking/SpeakingExercise';
import WritingExercise from './components/writing/WritingExercise';

const exerciseComponents = {
  'conversation': ConversationWriteExercise,
  'conversation-fillin': ConversationFillInExercise,
  'vocabulary': VocabularyFillInExercise,
  'grammar': GrammarFillInOrchestrator,
  'speaking': SpeakingExercise,
  'writing': WritingExercise
};

const AppContent = () => {
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [selectedExerciseType, setSelectedExerciseType] = useState(null);
  const [showDashboard, setShowDashboard] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
const { user, loading } = useAuth();

  const selectLesson = (topic) => {
    setSelectedTopic(topic);
    setSelectedExerciseType(null);
    setShowDashboard(false);
    setShowAdmin(false);
  };

  const selectExercise = (exerciseType) => {
    setSelectedExerciseType(exerciseType);
  };

  const backToLessons = () => {
    setSelectedTopic(null);
    setSelectedExerciseType(null);
    setShowDashboard(false);
    setShowAdmin(false);
  };

  const backToExerciseMenu = () => {
    setSelectedExerciseType(null);
  };

  const openDashboard = () => {
    setShowDashboard(true);
    setShowAdmin(false);
    setSelectedTopic(null);
  };

  const openAdmin = () => {
    if (user && user.is_admin) {
      setShowAdmin(true);
      setShowDashboard(false);
      setSelectedTopic(null);
    }
  };

  // Show loading while checking authentication
  if (loading) {
    return <Loading />;
  }

  let content = null;

  // Show login page if not authenticated
  if (!user) {
    content = <Login />;
  } else if (showAdmin) {
    // Show admin dashboard if selected
    content = <AdminDashboard onBackToLessons={backToLessons} />;
  } else if (showDashboard) {
    // Show dashboard if selected
    content = <Dashboard onBackToLessons={backToLessons} />;
  } else if (!selectedTopic) {
    // Show lesson menu if no lesson is selected
    content = (
      <LessonMenu
        onSelectLesson={selectLesson}
        onOpenDashboard={openDashboard}
        onOpenAdmin={openAdmin}
      />
    );
  } else if (selectedTopic && !selectedExerciseType) {
    // Show exercise menu if topic selected but no exercise type
    content = (
      <ExerciseMenu
        selectedTopic={selectedTopic}
        onStartExercise={selectExercise}
        onBack={backToLessons}
      />
    );
  } else {
    // Show selected exercise when both topic and exercise type are selected
    const ExerciseComponent = exerciseComponents[selectedExerciseType];
    if (ExerciseComponent) {
      content = (
        <div className="min-vh-100 bg-light">
          <ExerciseComponent
            key={`${selectedTopic}-${selectedExerciseType}`}
            topic={selectedTopic}
            onBack={backToExerciseMenu}
          />
        </div>
      );
    }
  }

  return (
    <>
      <OfflineBanner />
      {content}
      <ChatWidget user={user} />      
      {user && <BBBJoinButton meetingId="my-meeting-123" userName={user.username || user.email || 'Participant'} />}
      {user && <DictionaryPopupButton />}
    </>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;
